/**
 * Plugin contract — implement this shape (or use createPlugin).
 *
 * Lifecycle:
 *   register → onRegister(ctx)
 *   player ready → onReady(ctx)
 *   destroy → onDestroy(ctx)
 *
 * Plugins must not mutate the PlaybackEngine internals; use ctx.engine public API
 * and ctx.bus events.
 */

/**
 * @typedef {object} PluginContext
 * @property {object} engine
 * @property {object} config resolved player config
 * @property {object} bus shared emitter for plugin↔plugin / plugin↔UI
 * @property {function} getState
 */

/**
 * @param {object} definition
 * @returns {object}
 */
export function createPlugin(definition) {
  definition = definition || {};
  if (!definition.name) {
    throw new Error("Plugin requires a name");
  }
  return {
    name: definition.name,
    version: definition.version || "0.0.0",
    onRegister: definition.onRegister || function () {},
    onReady: definition.onReady || function () {},
    onDestroy: definition.onDestroy || function () {},
    onEvent: definition.onEvent || null,
  };
}

export default createPlugin;
